import { useEffect, useState } from "react";
import "../styles/modal.css";

const TaskModal = ({
  isOpen,
  onClose,
  onSave,
  onDelete,
  users,
  initialTask,
}) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    priority: "Medium",
    dueDate: "",
    assigneeId: "",
  });

  useEffect(() => {
    if (initialTask) {
      setForm({
        title: initialTask.title || "",
        description: initialTask.description || "",
        priority: initialTask.priority || "Medium",
        dueDate: initialTask.dueDate || "",
        assigneeId: initialTask.assigneeId || "",
      });
    } else {
      setForm({
        title: "",
        description: "",
        priority: "Medium",
        dueDate: "",
        assigneeId: "",
      });
    }
  }, [initialTask]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>{initialTask ? "Edit Task" : "Add Task"}</h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <label>
            Title
            <input
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Description
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
            />
          </label>
          <div className="modal-row">
            <label>
              Priority
              <select
                name="priority"
                value={form.priority}
                onChange={handleChange}
              >
                <option>High</option>
                <option>Medium</option>
                <option>Low</option>
              </select>
            </label>
            <label>
              Due Date
              <input
                type="date"
                name="dueDate"
                value={form.dueDate}
                onChange={handleChange}
              />
            </label>
          </div>
          <label>
            Assignee
            <select
              name="assigneeId"
              value={form.assigneeId}
              onChange={handleChange}
            >
              <option value="">Unassigned</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </select>
          </label>

          <div className="modal-footer">
            {initialTask && (
              <button
                type="button"
                className="btn-danger"
                onClick={onDelete}
              >
                Delete
              </button>
            )}
            <div className="modal-footer-right">
              <button
                type="button"
                className="btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn-primary">
                {initialTask ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaskModal;
